import { useState, type ReactNode } from 'react';
import { useI18n } from '../../../i18n';
import type { Lang } from '../../../i18n';

// SVG flags — simple, recognizable, render on all platforms
const FLAG_ES: ReactNode = (
  <svg width="20" height="14" viewBox="0 0 20 14" style={{ borderRadius: 2, display: 'block' }}>
    <rect width="20" height="14" fill="#C60B1E" />
    <rect y="3.5" width="20" height="7" fill="#FFC400" />
  </svg>
);

const FLAG_EN: ReactNode = (
  <svg width="20" height="14" viewBox="0 0 60 30" style={{ borderRadius: 2, display: 'block' }}>
    <rect width="60" height="30" fill="#00247D" />
    <path d="M0 0L60 30M60 0L0 30" stroke="#fff" strokeWidth="6" />
    <path d="M0 0L60 30M60 0L0 30" stroke="#CF142B" strokeWidth="2" />
    <path d="M30 0V30M0 15H60" stroke="#fff" strokeWidth="10" />
    <path d="M30 0V30M0 15H60" stroke="#CF142B" strokeWidth="6" />
  </svg>
);

const FLAG_ZH: ReactNode = (
  <svg width="20" height="14" viewBox="0 0 20 14" style={{ borderRadius: 2, display: 'block' }}>
    <rect width="20" height="14" fill="#DE2910" />
    <polygon
      points="4,2 4.6,3.8 6.5,3.8 5,4.9 5.5,6.7 4,5.6 2.5,6.7 3,4.9 1.5,3.8 3.4,3.8"
      fill="#FFDE00"
    />
  </svg>
);

const FLAGS: Record<Lang, ReactNode> = { es: FLAG_ES, en: FLAG_EN, zh: FLAG_ZH };
const LANGS: Lang[] = ['es', 'en', 'zh'];

export function LanguageSelector() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 30,
          borderRadius: 6,
          border: 'none',
          background: 'rgba(255,255,255,0.08)',
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.15)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.08)';
        }}
        title="Idioma"
      >
        {FLAGS[lang]}
      </button>

      {open && (
        <>
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 999 }}
            onClick={() => setOpen(false)}
          />
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              marginTop: 4,
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 1000,
            }}
          >
            {LANGS.map((l) => (
              <button
                key={l}
                onClick={() => {
                  setLang(l);
                  setOpen(false);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  padding: '8px 16px',
                  border: 'none',
                  background: lang === l ? '#F0F0F0' : '#fff',
                  cursor: 'pointer',
                  transition: 'background 0.1s',
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = '#F5F5F5';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background =
                    lang === l ? '#F0F0F0' : '#fff';
                }}
              >
                {FLAGS[l]}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
